import axios from "axios";
import { handleGraphQLError, APiUrl } from "../helper";

export const getHome = async () => {
    try {
        const response = await axios.post(
            APiUrl,
            {
                query: `query home { page(id: "316", idType: DATABASE_ID) { title homepage { heroSection { button card { description name ratingImage { node { sourceUrl } } tagline image { node { sourceUrl } } } description subtitle title features { line1 line2 } imageGif { node { sourceUrl } } rating { content image { node { sourceUrl } } } options { option1 option2 option3 } } videoUrl stagingImage { title logo1 { title logoImage { node { sourceUrl } } } logo2 { title logoImage { node { sourceUrl } } } logo3 { title logoImage { node { sourceUrl } } } logo4 { title logoImage { node { sourceUrl } } } logo5 { title logoImage { node { sourceUrl } } } logo6 { logoImage { node { sourceUrl } } title } logo7 { title logoImage { node { sourceUrl } } } logo8 { title logoImage { node { sourceUrl } } } } customersExperience { mainTitle testimonial1 { content title userName userPositions star userImage { node { sourceUrl } } } testimonial2 { content title userName userPositions star userImage { node { sourceUrl } } } testimonial3 { content title userName userPositions star userImage { node { sourceUrl } } } testimonial4 { content title userName userPositions star userImage { node { sourceUrl } } } testimonial5 { content title userName userPositions star userImage { node { sourceUrl } } } testimonial6 { content title userName userPositions star userImage { node { sourceUrl } } } } faq { faq1 { answer question } faq2 { answer question } faq3 { answer question } faq4 { answer question } faq5 { answer question } faq6 { answer question } faq7 { answer question } faq8 { answer question } faq9 { answer question } title faq10 { answer question } faq11 { answer question } subTitle } } } }`,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        const json = response.data;

        if (json.errors) {
            handleGraphQLError(json.errors[0].message);
        } else {
            return json?.data?.page?.homepage ?? [];
        }
    } catch (err) {
        handleGraphQLError(err.message);
    }
};



